/** @file transformReason: why the Pose block's fields are disabled, as the line under the rows. */
import type { JointEdit } from './useJointEdit';

/** No clip on the playhead, or the frame is in a mirrorHalf clip's computed half; null when the fields can be edited. */
export function transformReason(edit: JointEdit | null): string | null {
  if (edit === null) return 'Read-only: pick a clip in the timeline to key.';
  return edit.locked ? 'Locked: this frame is the computed mirrored half; edit the other half.' : null;
}
